import { url, header } from "../../apis/Index";
import { toast } from "react-toastify";
import axios from "axios";

export const getVisits = () => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_VISIT_INFO",
      fetchingLoaders: true,
    });
    axios
      .get(`${url}/v1/visits`, {
        headers: header,
      })
      .then((visits) => {
        dispatch({
          type: "GET_VISITS",
          visits,
        });
        dispatch({
          type: "GETTING_VISIT_INFO",
          fetchingLoaders: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GETTING_VISIT_INFO",
          fetchingLoaders: false,
        });
        dispatch({
          type: "SET_VISIT_FETCH_FAILED",
          message: "Failed to get visits",
        });
      });
  };
};

export const getVisitById = (id) => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_ONE_VISIT_INFO",
      fetchingLoaders: true,
    });
    axios
      .get(`${url}/v1/visits/${id}`, {
        headers: header,
      })
      .then((visit) => {
        dispatch({
          type: "GET_VISIT",
          visit,
        });
        dispatch({
          type: "GETTING_ONE_VISIT_INFO",
          fetchingLoaders: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GETTING_ONE_VISIT_INFO",
          fetchingLoaders: false,
        });
        dispatch({
          type: "GET_VISIT_FETCH_FAILED",
          message: "Failed to get visit",
        });
      });
  };
};

export const addnewVisit = (newVisit, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_VISIT_INFO",
      loader: true,
    });
    axios
      .post(`${url}/v1/visits`, newVisit, {
        headers: header,
      })
      .then((visit) => {
        dispatch({
          type: "CREATE_VISIT",
          visit,
        });
        dispatch({
          type: "SENDING_VISIT_INFO",
          loader: false,
        });
        closeFormAfterAdding();
        toast.success("Event registered", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch(() => {
        dispatch({
          type: "SENDING_VISIT_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_VISIT_MESSAGE",
          message: "Failed to register visit",
        });
      });
  };
};

export const updateVisit = (updatedVisit, id, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_VISIT_INFO",
      loader: true,
    });
    axios
      .put(`${url}/v1/visits/${id}`, updatedVisit, {
        headers: header,
      })
      .then((visit) => {
        dispatch({
          type: "UPDATE_VISIT",
          visit,
        });
        dispatch({
          type: "SENDING_VISIT_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch((error) => {
        dispatch({
          type: "SENDING_VISIT_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_VISIT_MESSAGE",
          message: "Failed to update visit info",
        });
      });
  };
};

export const deleteVisit = (id, redirectAfterDelete) => {
  return (dispatch) => {
    dispatch({
      type: "DELETING_VISIT_INFO",
      deletingAction: {
        id: id,
        deleting: true,
      },
    });
    axios
      .delete(`${url}/v1/visits/${id}`, {
        headers: header,
      })
      .then(() => {
        redirectAfterDelete();
        dispatch({
          type: "DELETE_VISIT",
          id,
        });
        dispatch({
          type: "DELETING_VISIT_INFO",
          deletingAction: {
            id: null,
            deleting: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: "DELETING_VISIT_INFO",
          deletingAction: {
            id: null,
            deleting: false,
          },
        });
        toast.error("Failed to delete event", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };
};
